import React, { FC } from 'react';

import { Invitations } from './Invitations';

import { RedirectIfNotOwner } from '#root/Components/Redirect';
import { usePartyTitle } from '#root/hooks/use-party-title';
import { useTranslation } from '#root/hooks/use-translation';

const PartyInvitations: FC = () => {
  const t = useTranslation();
  usePartyTitle(t(keys => keys.titles.invitations));

  return (
    <RedirectIfNotOwner>
      <Invitations />
    </RedirectIfNotOwner>
  );
};

export default PartyInvitations;
